import { render, staticRenderFns } from "./PreviewEditExamInfo.vue?vue&type=template&id=5a2ddbe2&scoped=true"
import script from "./PreviewEditExamInfo.vue?vue&type=script&lang=js"
export * from "./PreviewEditExamInfo.vue?vue&type=script&lang=js"
import style0 from "./PreviewEditExamInfo.vue?vue&type=style&index=0&id=5a2ddbe2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ddbe2",
  null
  
)

export default component.exports